import api from './api'

export interface TaskItem {
    id: number
    title: string
    description: string | null
    status: string
    priority: string
    created_by_id: number
    created_by_name: string | null
    assigned_to_id: number | null
    assigned_to_name: string | null
    // Задача на команду (профиль видимости): её видит и ведёт вся команда.
    visibility_profile_id?: number | null
    visibility_profile_name?: string | null
    deadline: string | null
    reminder_at: string | null
    reminder_sent: boolean
    lead_id: number | null
    lead_geo: string | null
    lead_title: string | null
    lead_crm_ww_id: string | null
    // Профиль видимости лида - команда, которой видна задача.
    lead_profile_name?: string | null
    lead_profile_email?: string | null
    chat_id: number | null
    contacts_hidden: boolean
    // Номер задачи в CRM Wiseway, если она связана с их базой.
    crm_task_id: number | null
    crm_origin: string | null
    close_comment: string | null
    // Приходит только в ответе на создание и закрытие: почему задача не
    // передалась в CRM Wiseway. На саму задачу не влияет.
    crm_warning?: string | null
    completed_at: string | null
    created_at: string
    updated_at: string
}

export interface TaskPayload {
    // Чем закрыли задачу - уходит в «Результат» их карточки в CRM.
    close_comment?: string | null
    title: string
    description?: string | null
    status?: string
    priority?: string
    assigned_to_id?: number | null
    visibility_profile_id?: number | null
    deadline?: string | null
    lead_id?: number | null
}

export interface ProfileOption {
    id: number
    name: string
}

export interface LeadOption {
    id: number
    label: string
    geo: string | null
    crm_ww_id: string | null
}

// Задачи. Каждый видит свои - назначенные ему или созданные им. С правом
// «Видеть задачи по другим сотрудникам» - ещё задачи младших по рангу.
// «Админ разработки» видит все. Разделение делает сервер.
export const tasksApi = {
    // Лиды для выбора в задаче: оператору - его собственные, админам - все.
    getLeadOptions: (search?: string) =>
        api.get<LeadOption[]>('/tasks/lead-options', { params: { search } }),

    getTasks: (params?: {
        status?: string
        priority?: string
        assigned_to?: number
        // open - активные, closed - выполненные и отменённые.
        state?: 'open' | 'closed'
        closed_from?: string
        closed_to?: string
        // Период по сроку задачи - работает и на активных, и на закрытых.
        due_from?: string
        due_to?: string
        // Период по времени постановки задачи.
        created_from?: string
        created_to?: string
        // Задачи одного лида - вкладка в его карточке.
        lead_id?: number
        // Только задачи на мои команды.
        team_only?: boolean
    }) =>
        api.get<TaskItem[]>('/tasks', { params }),

    createTask: (data: TaskPayload) => api.post<TaskItem>('/tasks', data),

    updateTask: (taskId: number, data: Partial<TaskPayload>) =>
        api.put<TaskItem>(`/tasks/${taskId}`, data),

    deleteTask: (taskId: number) => api.delete(`/tasks/${taskId}`),

    // Команды, на которые можно поставить задачу: свои, руководителям - все.
    getProfileOptions: () => api.get<ProfileOption[]>('/tasks/profile-options'),

    // «Взять себе» задачу команды.
    takeTask: (taskId: number) => api.post<TaskItem>(`/tasks/${taskId}/take`),
}
